import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as Logo } from '../svgs/logo.svg';


const Box = styled.div`
  header {
    margin: 30px auto;
    max-width: 800px;
    text-align: left;
    padding: 0 2rem;
  }

  main {
    margin: 0 auto;
    padding: 2rem;
    max-width: 800px;
    background-color: ${props => props.theme.colors.white};
    border-radius: 4px;
    border: 1px solid ${props => props.theme.colors.gray};

    h1 {
      margin: 0;
    }
  }

  footer {
    margin: 30px auto;
    max-width: 800px;
    text-align: center;
  }
`;


const Layout = () => (
  <Box>
    <header>
      <Logo />
    </header>
    <main>
      <Outlet />
    </main>
    <footer>
      COPYRIGHT © 2012-{(new Date()).getFullYear()} SOPHILABS, INC.
    </footer>
  </Box>
);

export default Layout;
